// components/ImportProspectsModal.jsx
import React from "react";
import { FaTimes, FaUpload } from "react-icons/fa";

export default function ImportProspectsModal({
  importRows,
  onFile,
  onImport,
  onClose,
}) {
  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="relative w-[95vw] max-w-xl rounded-3xl bg-white dark:bg-slate-900 p-5 border border-slate-200 dark:border-slate-800 shadow-2xl">
        <div className="flex items-start justify-between gap-3 mb-4">
          <div>
            <h3 className="font-semibold text-lg">Importer un CSV</h3>
            <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
              Ajoutez ou mettez à jour rapidement vos prospects.
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="rounded-full p-2 text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800"
          >
            <FaTimes />
          </button>
        </div>

        <div className="space-y-4 text-sm">
          <label className="block rounded-2xl border-2 border-dashed border-slate-300 dark:border-slate-700 p-5 text-center cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/60 transition">
            <FaUpload className="mx-auto text-2xl text-slate-400" />
            <div className="mt-2 font-medium">Choisir un fichier CSV</div>
            <div className="mt-1 text-xs text-slate-500">
              Format UTF-8 recommandé
            </div>

            <input
              type="file"
              accept=".csv,text/csv"
              onChange={(e) => onFile(e.target.files?.[0])}
              className="hidden"
            />
          </label>

          <div className="rounded-2xl bg-slate-50 dark:bg-slate-800/70 p-3 text-xs text-slate-600 dark:text-slate-300">
            Colonnes acceptées :{" "}
            <code>
              nom_club, discipline, departement_code, nb_licencies, email,
              telephone, contact_nom, fonction, statut, date_contact, site_url,
              site_status, facebook_url, observations
            </code>
          </div>

          {!!importRows.length && (
            <div className="rounded-2xl border border-slate-200 dark:border-slate-800 p-3">
              <div className="font-medium">
                {importRows.length} ligne(s) détectée(s)
              </div>

              <div className="mt-2 text-xs overflow-hidden">
                <code className="block rounded-xl bg-slate-100 dark:bg-slate-800 px-3 py-2">
                  {JSON.stringify(importRows[0]).slice(0, 220)}…
                </code>
              </div>
            </div>
          )}

          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-xl bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700"
            >
              Annuler
            </button>

            <button
              type="button"
              disabled={!importRows.length}
              onClick={onImport}
              className="px-4 py-2 rounded-xl bg-slate-950 text-white dark:bg-slate-100 dark:text-slate-950 hover:opacity-90 disabled:opacity-50"
            >
              Importer / mettre à jour
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}